<div class="flex-centered-vr-space-between-container border-gray-bottom pad-8-vr padding-hr">
    {{ isSuccess ? 'Subscription Renewed' : 'Payment Failed' }}
    <button mat-icon-button class="close-button mat-icon-16 overview-card" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="padding flex-centered-container-column">
    <ng-container *ngIf="isSuccess; else paymentFailed">
        <img src="/assets/images/new-blue-tick.svg" alt="Subscription Activated" class="margin-bottom">
        <div class="text-center margin-bot">
            Your Subscription has been successfully renewed for the <span class="font-bold">{{ planName }}</span>.
        </div>
    </ng-container>
</div>

<ng-template #paymentFailed>
    <div class="flex-centered-container margin-bot gap-16-px failed-container">
        <img src="/assets/images/new-red-failed.svg" alt="Subscription Activated" class="failed-image">
        <div class="text-danger font-20 font-bold">Payment Failed</div>
    </div>
    <div class="text-center margin-bot placeholder-text font-14">
        Your Plan has expired because the auto payment was unsuccessful due to insifficient funds in your bank account.
        Kindly Maintain sufficient funds and subscribe again.
    </div>

    <div class="font-16 font-bold full-width margin-bottom">Plan Details</div>

    <div class="pad-8-bottom full-width font-14 placeholder-text border-gray-bottom flex-centered-vr-space-between-container">
        <span>Plan Name</span>
        <span class="font-bold">{{ planName }}</span>
    </div>
    <div class="pad-8-vr full-width font-14 placeholder-text flex-centered-vr-space-between-container">
        <span>Required funds </span>
        <span class="font-bold">{{CURRENCY_LABEL}} {{requiredFunds | precision: DEFAULT_PRECISION | nullCheck}}</span>
    </div>
</ng-template>

<div class="padding border-dashed-top">
    <button mat-flat-button [tabIndex]="-1" color="accent" class="ut-pro-button full-width gradient pad-8-vr"
        (click)="routeToTransaction()" *ngIf="isSuccess; else plansButton">
        Check Transaction History
    </button>
</div>

<ng-template #plansButton>
    <button mat-flat-button [tabIndex]="-1" color="accent" class="ut-pro-button full-width gradient pad-8-vr"
        (click)="redirectToPlans()" *ngIf="!isSuccess">
        Subscribe Again
    </button>
</ng-template>